import axios from 'axios';

// 创建 axios 实例
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api', // 生产环境可通过环境变量配置，开发环境使用Vite代理
  timeout: 30000, // 服务器在美国，国内晚高峰跨境线路只有每秒十几 KB，10 秒常不够
});

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器 - 统一错误处理
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 清除本地存储的认证信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('team');
      
      // 跳转到登录页面（React Router 处理）
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;